import { render, staticRenderFns } from "./RailwayAddUpdate.vue?vue&type=template&id=9952faee"
import script from "./RailwayAddUpdate.vue?vue&type=script&lang=js"
export * from "./RailwayAddUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports